var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "icon-container" }, [
      _c(
        "a",
        { attrs: { href: "#opening-times" } },
        [
          _c("p", [_vm._v(_vm._s(_vm.$t("ticketList.openingTimes.headline")))]),
          _vm._v(" "),
          _c("Watch"),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "icon-container" }, [
      _c(
        "a",
        { attrs: { href: "#ticket-list" } },
        [
          _c("p", [_vm._v(_vm._s(_vm.$t("ticketList.buyTicket.headline")))]),
          _vm._v(" "),
          _c("Ticket"),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "icon-container" }, [
      _c(
        "a",
        { attrs: { href: "#ticket-code" } },
        [
          _c("p", [_vm._v(_vm._s(_vm.$t("ticketList.ticketCode.redeemCode")))]),
          _vm._v(" "),
          _c("Coupon"),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }